import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { environment } from '@pos-app/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  private toastr: any;

  constructor(private injector: Injector) {}

  handleError(err: any) {
    const errorText =
      err && typeof err.toString === 'function' ? err.toString() : '';
    const stackText =
      err && typeof err.stack === 'string' ? err.stack : '';

    const isExpressionChangedError =
      errorText.indexOf('ExpressionChangedAfterItHasBeenCheckedError') !== -1;
    const isUndefinedStreamError =
      errorText.indexOf("You provided 'undefined' where a stream was expected") !== -1;
    const isToastrStackError =
      stackText.indexOf('ngx-toastr') !== -1 ||
      errorText.indexOf('Expression location: Toast component') !== -1;

    if (!err || isExpressionChangedError || isUndefinedStreamError || isToastrStackError) {
      return;
    }

    if (!environment.production) {
      console.error(err);
    }

    this.toastr = this.injector.get(ToastrService);
    this.toastr.error(
      err.ErrorMessage
        ? err.ErrorMessage
        : 'There was an error when processing the data',
      'Error'
    );
  }
}

